import { FC, useContext } from "react";

import { SubmitButton, UseFormReturn, Form } from "capitalrx-components-2.0/lib/forms";
import { Button } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";

import { ProviderManagement } from "@/api/interfaces";
import { StatusFormBlock, PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";
import { ThemeSelectorContext } from "@/context";
import { getThemeButton } from "@/utils";

import { ProviderPaymentRemittanceDataForm, PaymentRemittanceGroupFields } from "./PaymentRemittanceGroupFields";


export interface PaymentRemittanceFormProps {
  readonly onCancel: () => void;
  readonly onSubmit: (data: ProviderPaymentRemittanceDataForm) => Promise<void>;
  readonly type: StatusFormBlock;
  readonly provider: ProviderManagement.ProviderSchema;
  readonly paymentPreference: ProviderManagement.PaymentPreferenceSchema;
  readonly setPaymentPreference: Function;
  readonly documents: ProviderManagement.DocumentSchema[];
  readonly form?: UseFormReturn<ProviderPaymentRemittanceDataForm>;
  readonly onEdit: () => void;
}

export const PaymentRemittanceForm: FC<PaymentRemittanceFormProps> = ({
  onCancel,
  onSubmit,
  onEdit,
  type,
  provider,
  paymentPreference,
  setPaymentPreference,
  documents,
  form,
}) => {
  const { isCompressed } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);
  const ButtonGroup = isCompressed ? Stack : Shelf;

  const readOnly = type === "complete";
  const { primary_color } = useContext(ThemeSelectorContext);

  return (
    <Form form={form} onSubmit={onSubmit}>
      <Stack spacing="large">
        <PaymentRemittanceGroupFields readOnly={readOnly} provider={provider} paymentPreference={paymentPreference} setPaymentPreference={setPaymentPreference} documents={documents} typeForm="create" onEdit={onEdit} />
        {type === "edit" && (
          <Stack alignment={isCompressed ? "span" : "left"}>
            <ButtonGroup spacing="small">
              <SubmitButton appearance={getThemeButton("primary", primary_color)} testId="edit_provider_payment_remittance_form_submit_button">
                Save
              </SubmitButton>
              <Button
                appearance={getThemeButton("secondary", primary_color)}
                onClick={onCancel}
                testId="edit_provider_payment_remittance_form_clear_fields_button"
              >
                Discard Changes
              </Button>
            </ButtonGroup>
          </Stack>
        )}
      </Stack>
    </Form>
  );
};
